(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["contact_us"] && !window.DesignMode) return;
  try {
    
  jQuery('#btn-contact-send').click(function () {
    var dataPost = JSON.stringify({
      tr: 'send-contact',
      name: jQuery('#contact_us_block_name_text_zone_id').val(),
      email: jQuery('#contact_us_block_email_text_zone_id').val(),
      phone: jQuery('#contact_us_block_phone_text_zone_id').val(),
      msg: jQuery('#contact_us_message_textarea_zone_id').val(),
    });

    const loaderError = jQuery('#loader-error');
    const loaderSuccess = jQuery('#loader-success');
    const btnSend = jQuery('#text-btn-send');
    const oldBtnText = btnSend.html();
    const newBtnText = 'SENDING...';
    const oldErrorText = 'An error occurred, please try again.';

    if (
      !jQuery('#contact_us_block_name_text_zone_id').val().length ||
      !jQuery('#contact_us_block_email_text_zone_id').val().length ||
      !jQuery('#contact_us_block_phone_text_zone_id').val().length ||
      !jQuery('#contact_us_message_textarea_zone_id').val().length
    ) {
      loaderError.html('All fields are mandatory.');
      loaderError.show();
      return false;
    }

    loaderError.hide();
    loaderSuccess.hide();

    jQuery.ajax({
      type: 'POST',
      url: 'https://drwonline.com.br/grwn/send-contact',
      data: dataPost,
      contentType: 'application/json',
      dataType: 'json',
      beforeSend: function () {
        loaderError.hide();
        loaderSuccess.hide();
        btnSend.attr('disabled', true);
        btnSend.html(newBtnText);
      },
      success: function (data) {
        btnSend.attr('disabled', false);
        btnSend.html(oldBtnText);

        if (!data.success) {
          loaderError.html(oldErrorText);
          loaderError.show();
          return false;
        }

        loaderSuccess.show();
        loaderError.hide();
      },
      error: function (jqXHR, textStatus, errorThrown) {
        loaderSuccess.hide();
        loaderError.html(oldErrorText);
        loaderError.show();
        btnSend.attr('disabled', false);
        btnSend.html(oldBtnText);
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

})();
